module.exports = __webpack_public_path__ + "img/insurance-card-mapd.1a93908.png";